import { globalPaths, companyPaths } from 'app/constants/routes';

import {
  ArrowLeftOutline,
  GiftOutline,
  MerchantOutline,
  HomeOutline,
  WarningOutline,
  FrameOutline,
  PeopleOutline,
  Profile2UserOutline,
  CardsOutline,
  UserOctagonOutline,
  BriefcaseOutline,
  ClockOutline,
  DocumentUploadOutline,
  SecuritySafeOutline,
  SettingsOutline,
  CalendarOutline,
  PeopleBold,
  WarningBold,
  MerchantBold,
  GiftBold,
  HomeBold,
  FrameBold,
  Profile2UserBold,
  CardsBold,
  CalendarBold,
  UserOctagonBold,
  BriefcaseBold,
  SecuritySafeBold,
  SettingsBold,
  CupOutline,
  CupBold,
  WalletOutline,
  WalletBold,
  TickSquareOutline,
  TickSquareBold,
} from '@aslanpay/portal-common-lib';

const NavLinkItems = {
  backToCompanies: {
    icon: ArrowLeftOutline,
    name: 'All companies',
    path: globalPaths.companies.path,
  },
  global: [
    {
      id: 'dashboard',
      name: 'Dashboard',
      icon: HomeOutline,
      activeIcon: HomeBold,
      path: globalPaths.dashboard.path,
    },
    {
      id: 'suspicious-activity',
      name: 'Suspicious activity',
      icon: WarningOutline,
      activeIcon: WarningBold,
      path: globalPaths.suspiciousActivity.path,
    },
    {
      id: 'approvals',
      name: 'Approvals',
      icon: SecuritySafeOutline,
      activeIcon: SecuritySafeBold,
      path: globalPaths.approvals.path,
    },
    {
      id: 'companies',
      name: 'All companies',
      icon: BriefcaseOutline,
      activeIcon: BriefcaseBold,
      path: globalPaths.companies.path,
    },
    {
      id: 'employees',
      icon: Profile2UserOutline,
      activeIcon: Profile2UserBold,
      name: 'All employees',
      path: globalPaths.employees.path,
    },
    {
      id: 'payroll-reports',
      name: 'All deduction reports',
      icon: CardsOutline,
      activeIcon: CardsBold,
      path: globalPaths.payrollReports.path,
    },
    {
      id: 'reconciliations',
      name: 'Reconciliations',
      icon: TickSquareOutline,
      activeIcon: TickSquareBold,
      path: globalPaths.reconciliations.path,
    },
    {
      id: 'merchants',
      name: 'Merchants',
      icon: MerchantOutline,
      activeIcon: MerchantBold,
      path: globalPaths.merchants.path,
    },
    {
      id: 'admins',
      name: 'All admins',
      icon: UserOctagonOutline,
      activeIcon: UserOctagonBold,
      path: globalPaths.admins.path,
    },
    {
      id: 'partners',
      name: 'Partners',
      icon: PeopleOutline,
      activeIcon: PeopleBold,
      path: globalPaths.partners.path,
    },
    {
      id: 'sync-history',
      name: 'Sync history',
      icon: ClockOutline,
      activeIcon: ClockOutline,
      path: globalPaths.syncHistory.path,
    },
    {
      id: 'systemSettings',
      name: 'System settings',
      icon: SettingsOutline,
      activeIcon: SettingsBold,
      path: globalPaths.systemSettings.path,
    },
  ],
  company: [
    {
      id: 'dashboard',
      name: 'Dashboard',
      icon: HomeOutline,
      activeIcon: HomeBold,
      path: companyPaths.dashboard.path,
    },
    {
      id: 'employees',
      name: 'Employees',
      icon: Profile2UserOutline,
      activeIcon: Profile2UserBold,
      path: companyPaths.employees.path,
    },
    {
      id: 'gifting',
      name: 'Gifting',
      icon: GiftOutline,
      activeIcon: GiftBold,
      path: companyPaths.gifting.path,
    },
    {
      id: 'recognitions',
      name: 'Reward & Recognition',
      icon: CupOutline,
      activeIcon: CupBold,
      path: companyPaths.recognitions.path,
    },
    {
      id: 'wallets-and-pots',
      name: 'Wallets & Pots',
      icon: WalletOutline,
      activeIcon: WalletBold,
      path: companyPaths.walletsAndPots.path,
    },
    {
      id: 'payroll-reports',
      name: 'Deduction reports',
      icon: CardsOutline,
      activeIcon: CardsBold,
      path: companyPaths.payrollReports.path,
    },
    {
      id: 'reconciliations',
      name: 'Reconciliations',
      icon: TickSquareOutline,
      activeIcon: TickSquareBold,
      path: companyPaths.reconciliations.path,
    },
    {
      id: 'pay-calendars',
      name: 'Pay calendars',
      icon: CalendarOutline,
      activeIcon: CalendarBold,
      path: companyPaths.payCalendars.path,
    },
    {
      id: 'admins',
      name: 'Admins',
      icon: UserOctagonOutline,
      activeIcon: UserOctagonBold,
      path: companyPaths.admins.path,
    },
    {
      id: 'uploaded-files',
      name: 'Uploaded files',
      icon: DocumentUploadOutline,
      activeIcon: DocumentUploadOutline,
      path: companyPaths.uploadedFiles.path,
    },
    {
      id: 'settings',
      name: 'Settings',
      icon: SettingsOutline,
      activeIcon: SettingsBold,
      path: companyPaths.settings.path,
    },
    {
      id: 'home',
      name: 'Home',
      icon: HomeOutline,
      activeIcon: HomeBold,
      path: companyPaths.home.path,
    },
    {
      id: 'analytics',
      name: 'Analytics',
      icon: FrameOutline,
      activeIcon: FrameBold,
      path: companyPaths.analytics.path,
    },
  ],
};

export default NavLinkItems;
